import { render, staticRenderFns } from "./attribute_edit.vue?vue&type=template&id=0503522b&scoped=true"
import script from "./attribute_edit.vue?vue&type=script&lang=js"
export * from "./attribute_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503522b",
  null
  
)

export default component.exports